export const getMigratedInitialMonetisationData = ( { type } ) => {

	let initialMonetisationData = [];

	switch ( type ) {
		case "live": {

			initialMonetisationData = {
				monetisationData: [
					{
						title   : "Complete Minimum Eligibility",
						options : [
							{
								totalvalue  : 0,
								targetValue : 50,
								description : "1. Gain 50 hours of Listening Hours",
								subtext     : "Hours"
							},
							{
								totalvalue  : 0,
								targetValue : 100,
								description : "2. Get 100 Followers",
								subtext     : "Followers"
							}
						]
					},
					{
						title       : "Profile sent for Approval",
						description : "Our Community team will inspect your profile for the quality of streams"
					},
					{
						title       : "Qualified For Monetisation",
						subtitle    : "Your profile has been qualified for monetisation.",
						description : "Total Earning This Month(May, 2023)",
						earnings    : 0
					}
				],
				monetisationStatus    : 0,
				modalState            : 0,
				isRejected            : false,
				nextApprovalDate      : "2023-05-26T08:45:31.604Z",
				isLiveStreamMonetised : false,
				isReelsMonetised      : false,
				showTotalEarning      : false
			};
			break;
		}

		case "reels": {
			initialMonetisationData = {
				monetisationData: [
					{
						title   : "Upload Content",
						options : [
							{
								description : "Upload 2 Reels in the last  7 days ",
								subtext     : "Uploaded",
								totalvalue  : 0,
								targetValue : 2
							}
						],
						options1: [
							{
								description : "Upload 2 Videos in the last  7 days.",
								subtext     : "Uploaded",
								totalvalue  : 0,
								targetValue : 2
							}
						]
					},
					{
						title   : "Complete Minimum Eligbility",
						options : [
							{
								description : "1. Gain 100 Followers",
								subtext     : "Followers",
								totalvalue  : 0,
								targetValue : 100
							}
						],
						options1: [
							{
								description : "2. Have at least 15K views on reels within the last 30 days.",
								subtext     : "Views",
								totalvalue  : 0,
								targetValue : 15000
							},
							{
								description : "Have at least 5K views on videos within the last 30 days.",
								subtext     : "Views",
								totalvalue  : 0,
								targetValue : 5000
							}
						]
					},
					{
						title       : "Profile sent for Approval",
						description : "Our Community team will inspect your profile for the quality of content"
					},
					{
						title       : "Qualified for Monetisation ",
						subtitle    : "HURRAYYY!! Your profile has been qualified for Reel Monetisation.",
						description : "Total Earning This Month(May, 2023)",
						earnings    : 0
					}
				],
				modalState            : 0,
				isRejected            : false,
				monetisationStatus    : 0,
				nextApprovalDate      : "2023-05-26T07:01:31.121Z",
				isLiveStreamMonetised : false,
				isReelsMonetised      : false
			};

			break;
		}

		default:
			break;

	}

	return initialMonetisationData;
};